<template lang="pug">
filter-detail-container(title="Filter Services" :save-mode="false" @back="back" @clear="clear" @save="save")
  template(v-slot:body)
    .px-6.pt-6.pb-2.text-md Choose the services(s) that you want to filter:
    .text-center.mt-8(v-if="isLoading")
      v-progress-circular(width="2" size="30" color="primary" indeterminate)
    div(v-else)
      div(v-for="service in services" :key="service.value")
        .d-flex.text-sm.pa-6.cursor-pointer.hover-bg(@click="clickItem(service.value)")
          yc-checkbox(v-model="selected" :value="service.value")
          .ml-4
            .font-medium {{ service.label }}
            .text-xs {{ service.company.name }}
        v-divider.basic300
    .px-4.py-3
      y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isLoading" @input="fetchServices")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'

export default {
  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },
  components: { FilterDetailContainer },
  data: () => ({
    isLoading: true,
    selected: [],
    services: [],
    page: 1,
    pageSize: 20,
    count: 0,
    isFetching: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  created () {
    this.fetchServices()
    if (this.filter.items) {
      this.selected = this.filter.items
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchServices () {
      this.isLoading = true
      const params = {
        fields: 'id,name,company',
        page: this.page,
        page_size: this.pageSize,
        booking_enabled: true,
        hq: this.company.id,
        expand: 'company'
      }
      this.$axios.get(`/clinics/${this.company.slug}/services`, { params })
      .then(resp => {
        this.count = resp.data.count
        this.services = resp.data.results.map(item => {
          return {
            label: item.name,
            value: `${item.id}`,
            company: item.company
          }
        })
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    save () {
      const filter = {}
      if (this.selected.length) {
        filter['items'] = this.selected
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back () {
      this.$emit('onBack')
    },
    clear () {
      this.selected = []
    },
    clickItem (value) {
      if (this.selected.includes(value)) {
        this.selected = this.selected.filter(x => x !== value)
      } else {
        this.selected.push(value)
      }
    }
  }
}
</script>